import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.for-each";
import "core-js/modules/es.array.index-of";
import "core-js/modules/es.array.splice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/web.dom-collections.for-each";
import _objectSpread from "D:/work/admin/datacenter_web/node_modules/@babel/runtime/helpers/esm/objectSpread2";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import { updateAutoServerConfig, addAutoServerConfig } from '@/api/gmtool/packageCode';
import { tabulation, gmTool, serchSelect } from "@/mixins/index";
export default {
  mixins: [tabulation, gmTool, serchSelect],
  data: function data() {
    return {
      paramsData: {
        id: '',
        is_active: "1",
        open_server_recharge_num: 100,
        // not_open_hour_duration: ['10', '17'],
        not_open_hour_duration_list: [['10', '17']],
        date_max_openserver_num: 2,
        // title: '',
        // content: '',
        main_content: [],
        open_server_register_num: 0,
        force_start_server_days: 1
      },
      paramsDataMark: {},
      dialogShow: false,
      reqLoading: false,
      rules: {
        special_product_id: [{
          required: true,
          message: this.$t('selectProduct'),
          trigger: "blur"
        }],
        is_prod: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        not_open_hour_duration: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        open_server_recharge_num: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        date_max_openserver_num: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        is_active: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        title: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        language: [{
          required: true,
          message: this.$t('pleaseChoose'),
          trigger: "blur"
        }],
        content: [{
          required: true,
          message: this.$t('pleaseAddAnnouncementContent'),
          trigger: "blur"
        }],
        open_server_register_num: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }],
        force_start_server_days: [{
          required: true,
          message: this.$t('pleaseInput'),
          trigger: "blur"
        }]
      },
      isMobile: false
    };
  },
  created: function created() {
    this.paramsDataMark = _objectSpread({}, this.paramsData);
    this.checkMobile();
    window.addEventListener('resize', this.handleResize);
  },
  beforeDestroy: function beforeDestroy() {
    window.removeEventListener('resize', this.handleResize);
  },
  methods: {
    handleResize: function handleResize() {
      this.checkMobile();
    },
    open: function open(data) {
      var _this = this;

      if (data) {
        console.log("===data", data);
        data.is_active = data.is_active.toString();
        var announce_template = JSON.parse(data.announce_template);
        console.log("announce_template", announce_template);
        var id = data.id,
            is_active = data.is_active,
            open_server_recharge_num = data.open_server_recharge_num,
            not_open_hour_duration = data.not_open_hour_duration,
            date_max_openserver_num = data.date_max_openserver_num,
            is_prod = data.is_prod,
            special_product_id = data.special_product_id,
            open_server_register_num = data.open_server_register_num,
            force_start_server_days = data.force_start_server_days; // const {title,content} = announce_template

        var timeRangeList = []; // if (Array.isArray(not_open_hour_duration) && not_open_hour_duration.length > 0 && Array.isArray(not_open_hour_duration[0])) {

        timeRangeList = not_open_hour_duration; // } 
        // 如果是普通的两个元素数组，说明是旧格式的单个时间段
        // else if (Array.isArray(not_open_hour_duration) && not_open_hour_duration.length == 2) {
        //   timeRangeList = [not_open_hour_duration];
        // } 

        console.log("timeRangeList==", timeRangeList);
        var getData = {
          id: id,
          is_active: is_active,
          open_server_recharge_num: open_server_recharge_num,
          not_open_hour_duration: not_open_hour_duration,
          date_max_openserver_num: date_max_openserver_num,
          is_prod: is_prod,
          // title,
          // content,
          special_product_id: special_product_id,
          main_content: [],
          open_server_register_num: open_server_register_num,
          force_start_server_days: force_start_server_days,
          not_open_hour_duration_list: timeRangeList
        };
        this.paramsData = _objectSpread({}, getData);
        announce_template.forEach(function (item) {
          _this.paramsData.main_content.push({
            language: item.language,
            content: item.content,
            title: item.title
          });
        });
      } else {
        this.pauseChange();
      }

      this.dialogShow = true;
    },
    addtag: function addtag(data, index) {
      this.paramsData.main_content[index].content = "".concat(this.paramsData.main_content[index].content).concat(data);
    },
    clearData: function clearData(isClearId) {
      this.paramsData = _objectSpread(_objectSpread({}, this.paramsDataMark), {}, {
        id: isClearId ? '' : this.paramsData.id
      });
      this.paramsData.not_open_hour_duration_list = [['10', '17']];
      this.$refs.ruleForm.clearValidate();
    },
    addContent: function addContent() {
      // if (this.paramsData.main_content.length) {
      this.paramsData.main_content.push({
        content: '',
        language: '',
        title: ''
      }); // }
    },
    removeContent: function removeContent(item) {
      var index = this.paramsData.main_content.indexOf(item);

      if (index !== -1) {
        this.paramsData.main_content.splice(index, 1);
      }
    },
    addTimeRange: function addTimeRange() {
      this.paramsData.not_open_hour_duration_list.push(['10', '17']);
    },
    // 删除时间段
    removeTimeRange: function removeTimeRange(index) {
      if (this.paramsData.not_open_hour_duration_list.length > 1) {
        this.paramsData.not_open_hour_duration_list.splice(index, 1);
      }
    },
    pauseChange: function pauseChange() {
      var _this2 = this;

      this.paramsData.main_content = [];
      this.$refs.ruleForm.clearValidate();
      this.paramsData.label = 0;
      this.langList.forEach(function (i) {
        _this2.paramsData.main_content.push({
          content: _this2.autoServerTitle[i.value],
          language: i.value,
          title: _this2.NewSuitlInTitle[i.value]
        });
      });
    },
    dataFormSubmit: function dataFormSubmit() {
      var _this3 = this;

      this.$refs.ruleForm.validate(function (valid) {
        if (valid) {
          _this3.reqLoading = true;
          var reqFn = _this3.paramsData.id !== '' ? updateAutoServerConfig : addAutoServerConfig; // this.paramsData.special_product_id= this.searchData.special_product_id;

          var params = {
            label: 0,
            priority: 4,
            force_push: true,
            start_time: null,
            end_time: null,
            server_range: null,
            channel: '-1',
            pause: 0,
            language: 'cn' // content: this.paramsData.content,
            // title: this.paramsData.title

          };
          var newData = [];

          _this3.paramsData.main_content.forEach(function (item) {
            newData.push(_objectSpread(_objectSpread({}, params), {}, {
              language: item.language,
              content: item.content,
              title: item.title
            }));
          });

          var submitData = _objectSpread(_objectSpread({}, _this3.paramsData), {}, {
            not_open_hour_duration: _this3.paramsData.not_open_hour_duration_list,
            announce_template: newData,
            game_id: _this3.rawData.game_id
          });

          delete submitData.not_open_hour_duration_list;
          reqFn(submitData).then(function (res) {
            if (res.code == 200) {
              _this3.reqLoading = false;

              _this3.$message({
                message: _this3.$t('operationSuccess'),
                type: 'success'
              });

              _this3.dialogShow = false;

              _this3.$emit('update');
            }
          }).finally(function () {
            _this3.reqLoading = false;
          });
        }
      });
    }
  }
};